<template>
    <div>
        <!-- mensajes de confirmacion -->
        <mensajeSistema></mensajeSistema>

        <!-- boton crear -->
        <v-row>
            <v-col cols="12" class="d-flex justify-end">
                <ButtonComp @click="agregarAlumno('agregar')" textButton="Registrar estudiante" normalButton iconBut="fas fa-plus" />
            </v-col>
        </v-row>


        <!-- modal confirmación para eliminar alumno -->
        <ComunDialogComp v-model="showModalElimnarAlumno" Deletedialog @close-modal="showModalElimnarAlumno = false"
            titleWindow="Eliminar registro" @cancel-item="showModalElimnarAlumno = false" @delete-item="eliminarAlumno">
            <template v-slot:body>
                <h3>¿Está seguro de eliminar este registro?</h3>
            </template>
        </ComunDialogComp>


        <!-- modal confirmación para eliminar familiar -->
        <ComunDialogComp v-model="showModalEliminarFamiliar" Deletedialog @close-modal="showModalEliminarFamiliar = false"
            @delete-item="eliminarFamiliar" titleWindow="Eliminar familiar" @cancel-item="showModalEliminarFamiliar = false">
            <template v-slot:body>
                <h3>{{ msgDelete }}</h3>
            </template>
        </ComunDialogComp>
      



        <!-- modal lista de familiares -->
        <ComunDialogComp v-model="showModalListaFamiliar" title="Grupo familiar" maxWidth="1000"
            @close-modal="cerrarModalFamiliar">
            <template v-slot:body>
         
                <ComundataTablecomp :headers="headersTableFamiliar" :items="listFamiliar" whitSearch :search="search"
                    noResultsText="Sin familiares registrados">
                    <template v-slot:apoderado="{ item }">
                
                        <v-chip @click="seleccionarApoderado(item.id_familia)" v-if="item.es_encargado == 1"
                            color="success">Encargado</v-chip>
                        <v-chip @click="seleccionarApoderado(item.id_familia)" v-else>Encargado</v-chip>
                    </template>
                  
                    <template v-slot:estado="{ item }">
                        <v-chip  v-if="item.familia['estado_familia'] == 1" class="color_activo"> Activo </v-chip>
                        <v-chip v-if="item.familia['estado_familia'] == 0" class="color_inactivo"> Inactivo </v-chip>
                    </template>

                    <!--ver datos familiar -->
                    <template v-slot:ver_datos_familiar="{ item }">
                        <ButtonComp :disabled="componenteEvento.visualizar_submodulo != 1" @click="verFamiliar(item, 'ver')"
                            verButton tooltipText="Ver familiar" />
                    </template>


                    <!--editar familiar -->
                    <template v-slot:editar_familiar="{ item }">
                        <ButtonComp :disabled="componenteEvento.editar_submodulo != 1" @click="editarFamiliar(item, 'editar')"
                            editButton tooltipText="Editar familiar" />
                    </template>

                    <!-- eliminar familiar -->

                    <template v-slot:eliminar_familiar="{ item }">
                        <ButtonComp :disabled="componenteEvento.borrar_submodulo != 1"
                            @click="confirmarEliminarFamiliar(item)" deleteButton tooltipText="Eliminar familiar" />
                    </template>
                </ComundataTablecomp>
            </template>
        </ComunDialogComp>


        <!-- tabla donde muestra la lista de alumnos -->
        <v-row>
            <v-col cols="12">
                <ComundataTablecomp :headers="headersTableAlumno" :items="listAlumnos" whitSearch :search="search"
                    noResultsText="Sin estudiantes matriculados">
                    <template v-slot:agregar_miembros="{ item }">
                        <ButtonComp :disabled="componenteEvento.agregar_submodulo != 1" @click="agregarFamiliar(item, 'agregar')"
                            textButton="Agregar familiares" iconBut="fas fa-plus" />
                    </template>

                    <!-- ver grupo familiar -->
                    <template v-slot:grupo_familiar="{ item }">
                        <ButtonComp :disabled="componenteEvento.visualizar_submodulo != 1"
                            @click="abrirModalFamiliar(item.id)" iconBut="fas fa-users" textButton="ver familiares" />
                    </template>

                    <!--ver alumno -->
                    <template v-slot:ver_alumno="{ item }">
                        <ButtonComp :disabled="componenteEvento.visualizar_submodulo != 1" @click="verAlumno(item, 'ver')"
                            verButton tooltipText="Ver registro del estudiante" />
                    </template>



                    <template v-slot:estado_alumno="{ item }">
                        <v-chip v-if="item.estado_alumno === 1" class="color_activo" small>Activo</v-chip>
                        <v-chip v-if="item.estado_alumno === 0" class="color_inactivo" small>Inactivo</v-chip>
                    </template>


                    <!--editar alumno -->
                    <template v-slot:editar_alumno="{ item }">
                        <ButtonComp :disabled="componenteEvento.editar_submodulo != 1" @click="editarAlumno(item,'editar')"
                            editButton tooltipText="Editar registro del estudiante" />
                    </template>

                    <!-- eliminar alumno -->

                    <template v-slot:eliminar_alumno="{ item }">
                        <ButtonComp :disabled="componenteEvento.borrar_submodulo != 1"
                            @click="confirmarEliminarAlumno(item)" deleteButton
                            tooltipText="Eliminar registro del estudiante" />
                    </template>
                </ComundataTablecomp>
            </v-col>
        </v-row>



        <span v-if="test">
            Eventos : <code>{{ componenteEvento }}</code>
        </span>
    </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import axios from '@/helpers/axios'
import { headersTableAlumno, headersTableFamiliar } from '../../../helpers/headersTable';
import ButtonComp from '../../../components/ComponentsEst/TableButtonComp.vue'
import ComundataTablecomp from '../../../components/ComponentsEst/ComundataTablecomp.vue'
import ComunDialogComp from '../../../components/ComponentsEst/ComunDialogComp.vue'

export default {

    components: {
        ButtonComp,
        ComundataTablecomp,
        ComunDialogComp
    },
    data() {
        return {
            test: false,
            search: '',
            paramComponente: { "id_modulo": 6, 'id_submodulo': 17 }, //sud_modulo y modulo
            listAlumnos: [],
            headersTableAlumno,
            headersTableFamiliar,
            listFamiliar: [],
            idColegio: parseInt(sessionStorage.getItem('id_colegio')),
            idAlumno: '',
            idFamiliar: '',
            showModalListaFamiliar: false,
            showModalEliminarFamiliar: false,
            showModalElimnarAlumno: false,
            msgDelete: '¿Desea eliminar este registro?'
        }
    },
    mounted() {
        //obtenemos la lista de alumnos
        setTimeout(() => {
            this.getMainList()
        }, 900)
    },

    created() {
        this.actualizarParamentro()
        
    },

    destroyed() {
        this.listAlumnos = []
        this.listFamiliar = []
    },



    computed: {
        ...mapGetters('login', ['componenteEvento']),
    },

    methods: {
        ...mapActions('login', ['parametroComponente']),
        //  ------- MENSAJE DE SISTEMA  --------


        ...mapMutations('mensajeSis', ['setEnviarMens']),

        actualizarParamentro() {
            this.parametroComponente(this.paramComponente)
        },




        async getMainList() {
            try {
                let response = await axios.post('/administrativo/alumno/getListAlumnos', {
                    idColegio: this.idColegio,
                    search: this.search
                })
                response = response.data
                if (response.messageT == 'S') {
                    if (response.payload.length === 0) {
                        this.setEnviarMens({ tipo: "W", mensaje: `No hay datos displonibles.`, tiempo: null })
                    }
                    this.listAlumnos = response.payload
                } else {
                    this.setEnviarMens({ tipo: "E", mensaje: `No se pudo cargar lista de alumnos.`, tiempo: null })
                }
                //this.idAlumno = ''

            } catch (e) {
                this.setEnviarMens({ tipo: "E", mensaje: `No se pudo cargar lista de alumnos.`, tiempo: null })
            }
        },
        async getMainListFamiliar() {
            try {
                let response = await axios.post('/administrativo/alumno/getListFamiliares', {
                    idColegio: this.idColegio,
                    idAlumno: this.idAlumno
                })
                response = response.data
                console.log("response: ", response)

                if (response.messageT == 'S') {
                    if (response.payload.length === 0) {
                        this.setEnviarMens({ tipo: 'E', mensaje: 'No hay datos disponibles.', tiempo: null })
                        setTimeout(() => {
                            this.cerrarModalFamiliar()
                        }, 1000);
                    } else {
                        this.listFamiliar = response.payload
                    }
                } else {
                    this.setEnviarMens({ tipo: 'E', mensaje: 'No hay información para mostrar', tiempo: null })
                }

            } catch (e) {
                this.setEnviarMens({ tipo: "E", mensaje: `No se pudo cargar lista de familiares.`, tiempo: null })
            }
        },
        cerrarModalFamiliar() {
            this.idAlumno = ''
            this.listFamiliar = []
            this.showModalListaFamiliar = false
        },
        async abrirModalFamiliar(idAlumno) {
            this.idAlumno = idAlumno
            this.showModalListaFamiliar = true
            await this.getMainListFamiliar()
        },
        agregarFamiliar(alumno, evento) {
            this.$router.push({path:`/registroacademico/familiar/alumno/${alumno.id}`, query:{evento:evento}})
        },
        async eventoBuscar() {
            await this.getMainList()
        },
        confirmarEliminarAlumno(alumno) {
            this.idAlumno = alumno.id
            this.showModalElimnarAlumno = true
        },
        confirmarEliminarFamiliar(familiar) {
            this.idFamiliar = familiar.id_familia
            this.showModalEliminarFamiliar = true
        },
        async eliminarAlumno() {
            try {
                let response = await axios.post('/administrativo/alumno/eliminarAlumno', {
                    idColegio: this.idColegio,
                    idAlumno: this.idAlumno
                })

                response = response.data


                this.setEnviarMens({ tipo: "S", mensaje: `¡Información eliminada con éxito!`, tiempo: null })

                if (response.messageT == 'S') {
                    await this.getMainList()
                    this.showModalElimnarAlumno = false
                }
                this.idAlumno = ''
            } catch (e) {
                this.setEnviarMens({ tipo: "E", mensaje: `Ups! algo falló, por favor vuélvalo a intentar.`, tiempo: null })

            }
        },
        async seleccionarApoderado(idFamiliar) {
            try {
                this.setEnviarMens({ tipo: 'S', mensaje: 'Actualizando apoderado...', tiempo: null })
                await axios.post('/administrativo/alumno/setFamiliarApoderado', {
                    idColegio: this.idColegio,
                    idAlumno: this.idAlumno,
                    idFamiliarApoderado: idFamiliar
                }).then(async (response) => {
                 
                    let data = response.data

                    if (data.messageT == 'S') {
                        setTimeout(async () => {
                            this.listFamiliar = []
                            this.listAlumnos = []
                            await this.getMainListFamiliar()
                            await this.getMainList()
                            this.setEnviarMens({ tipo: data.messageT, mensaje: data.message, tiempo: null })
                        }, 2000);
                    } else {
                        this.setEnviarMens({ tipo: data.messageT, mensaje: data.message, tiempo: null })
                    }
                })



            } catch (e) {
                this.setEnviarMens({ tipo: "E", mensaje: `Ups! algo falló, por favor vuélvalo a intentar.`, tiempo: null })
            }
        },
        async eliminarFamiliar() {
            try {
                let response = await axios.post('/administrativo/alumno/eliminarFamiliar', {
                    idColegio: this.idColegio,
                    idFamiliar: this.idFamiliar,
                    idAlumno: this.idAlumno
                })

                response = response.data
                console.log("response: ", response)
                this.setEnviarMens({ tipo: response.messageT, mensaje: response.message, tiempo: null })

                if (response.messageT == 'S') {
                    console.log("entre")
                    setTimeout(async () => {
                       let data= await this.getMainListFamiliar()
                        console.log("data", data)
                    }, 800)
                    this.showModalEliminarFamiliar = false
                }
                this.idFamiliar = ''
                let info = await this.getMainList()
                console.log("info",info)
            } catch (e) {
                this.setEnviarMens({ tipo: "E", mensaje: `Ups! algo falló, por favor vuélvalo a intentar.`, tiempo: null })

            }
        },
        agregarAlumno(evento) {
            this.$router.push({path:'/registroacademico/alumno', query:{evento:evento}})
        },
        editarAlumno(alumno, evento) {
            this.$router.push({path:'/registroacademico/alumno/' + alumno.id, query:{evento:evento, alumno:alumno}})
        },
        editarFamiliar(item, evento) {
            let idAlumno = item.id_alumno
            let idFamilia = item.id_familia
            this.$router.push({path:`/registroacademico/familiar/${idFamilia}/alumno/${idAlumno}`, query:{evento:evento, item:item}})
        },
        verFamiliar(item, evento) {
            let idAlumno = item.id_alumno
            let idFamilia = item.id_familia
            //this.$router.push(`/registroacademico/familiar/${familiar.id}/alumno/${idAlumno}`)
            this.$router.push({ name: 'registroacademico_familiar_editar', params: { idFamiliar: idFamilia, idAlumno: idAlumno, editarFamiliar: 0, evento:evento, item:item } })
        },
        verAlumno(alumno, evento) {
            this.$router.push({ name: 'registroacademico_alumno_editar', params: { id: alumno.id, editarAlumno: 0, evento: evento, persona:alumno.persona }})

        },
    }
}
</script>
<style>
.btn_grupo_familiar {
    color: #ffbc00 !important
}
</style>